import React from 'react';
import tinycolor from 'tinycolor2';

const MinimalistWhale = (props) => {
  const { radius, cells } = props;
  const base = cells[1].background;
  const dark = tinycolor(base).darken(10).toString();
  const light = tinycolor(base).lighten(15).toString();

  return (
    
    <svg width={`${radius * 2.25}px`} height={`${radius * 1.5}px`} x={`-${radius * 1.25}px`} y={`-${radius * .30}px`} viewBox="0 0 225 150" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Artboard">
            <g id="Group">
              <path d="M25,25 C11.1928813,25 0,13.8071187 0,7.10542736e-15 L25,0" id="Oval-2" fill={dark}></path>
              <path d="M161,149.82233 C144.431458,149.82233 131,136.390873 131,119.82233 L161,119.82233 L161,149.82233 Z" id="Oval-2-Copy-2" fill={dark}></path>
              <path d="M28,25 C41.8071187,25 53,13.8071187 53,7.10542736e-15 L28,0" id="Oval-2" fill={dark}></path>
              <path d="M142,7.32233047 C132.335017,-2.44077682 116.664983,-2.44077682 107,7.32233047 L124.5,25 L142,7.32233047 Z" id="Oval-2" fill={light}></path>
              <path d="M125,130 C69.771525,130 25,85.228475 25,30 L125,30 L125,130 Z" id="Oval-2" fill={base}></path>
              <path d="M125,130 C180.228475,130 225,85.228475 225,30 L125,30 L125,130 Z" id="Oval-2" fill={base}></path>
            </g>
          </g>
        </g>
    </svg>
  )
}
export default MinimalistWhale;

export function resize(props) {
  const {radius, minX, minY, maxY} = props;

  return {
    ...props,
    minX: minX + radius * .25,
    minY: minY + radius * .35,
    maxY: maxY + radius * .25,
  };
}



// WEBPACK FOOTER //
// ./src/core/thematic/minimalist/whale.js